// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"RenameFileModal_buttonsWrapper__UjSXP","title":"RenameFileModal_title__XHiHs","overlay":"RenameFileModal_overlay__PH87X","body":"RenameFileModal_body__EPVcF"};